// PageTitleContext.jsx
import React, { createContext, useContext, useState } from 'react';

const PageTitleContext = createContext();

export const usePageTitle = () => useContext(PageTitleContext);

export const PageTitleProvider = ({ children }) => {
  const [title, setTitle] = useState('');
  const [titleIcon, setTitleIcon] = useState(null);
  // A custom React node (e.g. a patient's initials avatar) shown instead of
  // titleIcon when set — takes priority since it's the more specific choice.
  const [titleAvatar, setTitleAvatar] = useState(null);
  // A custom React node (e.g. a status badge) shown right after the title text.
  const [titleBadge, setTitleBadge] = useState(null);
  // Small muted text shown on its own line below the title (e.g. a full address).
  const [titleDescription, setTitleDescription] = useState(null);

  return (
    <PageTitleContext.Provider value={{
      title, setTitle,
      titleIcon, setTitleIcon,
      titleAvatar, setTitleAvatar,
      titleBadge, setTitleBadge,
      titleDescription, setTitleDescription,
    }}>
      {children}
    </PageTitleContext.Provider>
  );
};
